import {TFontOptions} from './types';

export const FONT_FAMILY_OPTIONS: TFontOptions[] = [
    {label: 'Arial', value: 'Arial'},
    {label: 'Courier New', value: 'Courier New'},
    {label: 'Georgia', value: 'Georgia'},
    {label: 'Times New Roman', value: 'Times New Roman'},
    {label: 'Trebuchet MS', value: 'Trebuchet MS'},
    {label: 'Verdana', value: 'Verdana'}
];

export const FONT_SIZE_OPTIONS: TFontOptions[] = [
    {label: '8', value: '8'},
    {label: '9', value: '9'},
    {label: '10', value: '10'},
    {label: '11', value: '11'},
    {label: '12', value: '12'},
    {label: '14', value: '14'},
    {label: '16', value: '16'},
    {label: '18', value: '18'},
    {label: '20', value: '20'},
    {label: '22', value: '22'},
    {label: '24', value: '24'},
    {label: '26', value: '26'},
    {label: '28', value: '28'},
    {label: '36', value: '36'},
    {label: '48', value: '48'},
    {label: '72', value: '72'}
];

export const EMAIL_EDITOR = 'EmailEditor';

export const FONT_SIZE = 'font-size';
export const LINE_HEIGHT = 'line-height';
